<template>
  <div>
    <SelectionRequiredDialog /> 
    <PrintAzPersonsA4LabelsDialog />
    <DeletionDialog :context="'Selected' + context" />	
    <ErrorDialog />
    <ConfirmationDialog />
    <AzPersonsAssignTemplatesDialog />
    <ShowConnectionsAzPersonsDialog />
    <ReassignConnectionsAzPersonsDialog />
    <ManageTagsDialog 
			context="AzPersons" 
			dir='az/persons'
			idAttributeName='alvIds'
		/>
    <SyncDataDialog 
      context="AzPersons" 
			dir='az/persons'
			idAttributeName='alvIds'
    />
    <FileImportDialog :alvqaContext="alvqa + '-list'">
      <template v-slot:importOptions>
        <v-row v-if="isMappingImport">
          <v-col>
            <BaseEditPageDropdown
                :context="context"
                field="ImportSelectedMapping"
                :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                :items="mappingAbbreviations"
                :clearable="false"
                :withMargin="false"
                :alvqa="alvqa + '-mapping-import-dropdown-select-abbreviation'"
              />
          </v-col>
        </v-row>
        <v-row v-if="isMappingImport" justify="center">
          <v-col>
            <BaseEditPageTextField
              :context="context"
              field="ImportTags"
              :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
              :withMargin="false"
              :alvqa="alvqa + '-list-import-dialog-textfield-tags'"
            />
          </v-col>
        </v-row>
      </template>
    </FileImportDialog>
    <ImageUploadDialog headline="lang_GENERAL_CAPTION_UPLOAD_IMAGE" />
	

    <BaseListPage
      headline="lang_AZ_PERSONS"
      :context="context"
      :alvqa="alvqa"
    >
    <template v-slot:filter>
      <v-col cols="2">
					<DropdownFilter 
						:context="context + 'QualityFilter'"
						label="lang_GENERIC_CAPTION_QUALITY"
						:items="qualityItems"
						:alvqa="alvqa + '-list-dropdown-quality'"
					/>
				</v-col>
      <v-col cols="3">
					<DropdownFilter 
						:context="context + 'VisibilityFilter'"
						label="lang_AZ_PERSONS_CAPTION_VISIBILITY"
						:items="visibilityFilterItems"
						:multiple="true"
						:clearable="false"
						:alvqa="alvqa + '-list-dropdown-visibility'"
					/>
				</v-col>
    </template>
    <!-- DATA TABLE COMPONENT -->
      <template v-slot:dataTable>
        <BaseDataTableList 
          :headers="headers"
          :context="context"
          :alvqa="alvqa"
          :hasServerSideSorting="true"
          readOnlyGhostTdSpan="1"
        >
        <!-- TOPSLOT: actions, imports etc. -->
          <template v-slot:topSlot><AzPersonsTopSlot /></template>
        <!-- DATA TABLE CONTENT: columns -->
					<template v-slot:body="{ item }">
            <ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
            <td>
              <v-img
                :src="
                  item.item.picture !== undefined && item.item.picture !== null
                    ? item.item.picture
                    : require('@/assets/default_picture/default.jpg')
                "
                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                width="40px"
              ></v-img>
            </td>
						<td class="ellipsis">
              <BaseTooltip>
                <template v-slot:text>{{ getNameTooltip(item.item) }}</template>
                  <template v-slot:content>
                      <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-name'">
                          {{ $alvPlugin.getNameInternational(item.item) }}
                      </span>
                  </template>
              </BaseTooltip>
            </td>
            <td class="ellipsis">
              <BaseTooltip>
                <template v-slot:text>{{ item.item.group }}</template>
                  <template v-slot:content>
                      <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-group'">
                          {{ item.item.group }}
                      </span>
                  </template>
              </BaseTooltip>
						</td>
						<td 
              class="no_ellipsis"
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-city'"
            >
							{{ item.item.city }}
						</td>
            
            <td class="no_ellipsis" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-phone'">
                {{ item.item.phone }}
            </td>

						<td 
              class="no_ellipsis"
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-email'"
            >
							{{ item.item.email }}
						</td>
            <td 
              class="no_ellipsis"
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alv-id'"
            >
              {{ item.item.alvId }}
            </td>
            <td class="no_ellipsis">
              <BaseIcon   
                  :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-upload-picture'"
                  icon="photo" 
                  :tooltipText="item.item.picture ? 'lang_GENERIC_CAPTION_CHANGE_IMAGE':'lang_GENERIC_CAPTION_UPLOAD_IMAGE'"
                  :color="item.item.picture ? 'buttonStandard' : 'standardBrownIcon'"
                  @click.stop="showImageUploadDialog(item.item)"
              /> 
            </td>
					</template>

          <template v-slot:expandSlot="{ id }"><AzPersonsReadOnly :itemId='id' /></template>  
        
        </BaseDataTableList>
      </template>
    </BaseListPage>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseIcon from '@/components/_buttons/BaseIcon'
import AzPersonsAssignTemplatesDialog from './_dialogs/AzPersonsAssignTemplatesDialog.vue'
import ConfirmationDialog from '@/components/_dialogs/ConfirmationDialog.vue'

import AzPersonsTopSlot from './AzPersonsTopSlot'
import AzPersonsReadOnly from "./_readonly/AzPersonsReadOnly"

import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import PrintAzPersonsA4LabelsDialog from './_dialogs/PrintAzPersonsA4LabelsDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ErrorDialog from '@/components/_dialogs/ErrorDialog'
import ShowConnectionsAzPersonsDialog from './_dialogs/ShowConnectionsAzPersonsDialog.vue'
import ReassignConnectionsAzPersonsDialog from './_dialogs/ReassignConnectionsAzPersonsDialog.vue'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import SyncDataDialog from '@/components/_dialogs/SyncDataDialog'
import DropdownFilter from '@/components/_filters/DropdownFilter'
import ImageUploadDialog from '@/components/_dialogs/ImageUploadDialog.vue'

// import ReassignConnectionsDialog from '@/components/_dialogs/ManageTagsDialog'

export default {
  name: 'AzPersonsList',
  components: {
    BaseListPage,
    BaseDataTableList,
    BaseEditPageDropdown,
    BaseEditPageTextField,
    BaseTooltip,
    ExpandIcon,
    AzPersonsTopSlot,
    AzPersonsReadOnly,
    SelectionRequiredDialog,
    PrintAzPersonsA4LabelsDialog,
    FileImportDialog,
    DeletionDialog,
    ErrorDialog,
    ShowConnectionsAzPersonsDialog,
    ReassignConnectionsAzPersonsDialog,
    ManageTagsDialog,
    SyncDataDialog,
    DropdownFilter,
    ImageUploadDialog,
    BaseIcon,
    AzPersonsAssignTemplatesDialog,
    ConfirmationDialog
},
  data() {
    return {
      context: "AzPersons",
      alvqa: "az-persons",
      publishingStatementsMappings: []
    }
  },
  computed: {
    ...mapGetters(['getAzPersonsSearch']),

    headers() {
      return [
        {
            text: '', 
            value: 'data-table-select', 
            align: 'center',
            width: "60px",
            sortable: false,
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'data-table-expand',
            align: 'center', 
            width: "48px",
            sortable: false,
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'picture', 
            align: 'center',
            width: "65px",
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_NAME'), 
            value: 'name',
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_GROUP'), 
            value: 'group',
            align: 'left', 
            sortable: false,  
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_CITY'), 
            value: 'city',
            align: 'left', 
            sortable: true,
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_PHONE'), 
            value: 'phone',
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_EMAIL'), 
            value: 'email',
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_CAPTION_ALVID'),
            value: 'alvId', 
            align: 'left', 
            sortable: true,
            width: "170px",
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'editForm',
            align: 'right',
            sortable: false,
            width: "70px",
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'uploadPicture',
            align: 'right',
            sortable: false,
            width: "70px",
            class: 'text-no-wrap'
        }
      ]
    },
    qualityItems() {
      return[ 
        {
            text: this.$t('lang_GENERIC_CAPTION_FIND_DUPLICATES'), 
            value: 'duplicates',
            alvqa: this.alvqa + '-list-dropdown-quality-duplicates'
        },
        {
            text: this.$t('lang_AZ_PERSONS_CAPTION_NO_CONNECTIONS'),
            value: 'noConnections',
            alvqa: this.alvqa + '-list-dropdown-quality-no-connections'
        },
      ]
    },
    visibilityFilterItems() {
      return [
        { text: this.$t('lang_GENERIC_VISIBLE'), value: 'visible', alvqa: this.alvqa + '-list-dropdown-visibility-visible' },
        { text: this.$t('lang_GENERIC_HIDDEN'), value: 'hidden', alvqa: this.alvqa + '-list-dropdown-visibility-hidden' },
        { text: this.$t('lang_GENERIC_CAPTION_MOBILE_APP'), value: 'mobile', alvqa: this.alvqa + '-list-dropdown-visibility-mobile' }
      ]
    },
    isMappingImport() {
      return this.$store.getters.getSelectedFileImport === 'mappingImport';
    },
    mappingAbbreviations() {
			let mappingsList = this.$store.getters.getMappings
      let retArr = []
      
      mappingsList.forEach((v) => {
				if (v.direction !== 'import') return;
        retArr.push({
            value: v.alvId,
            text: v.abbreviation,
            alvqa: this.alvqa + `-import-mapping-${v.alvId}`,
            disabled: v.columnMappingsCount === 0, // Disable if no column mappings exist for this mapping
        })
      })

      // Sort by ALVID descending (highest first)
      retArr.sort((a, b) => {
        if (a.disabled === true) return 1; // Put disabled at the end
        if (b.disabled === true) return -1;
        const alvIdA = parseInt(a.value.replace(/\D/g, '')) || 0
        const alvIdB = parseInt(b.value.replace(/\D/g, '')) || 0
        return alvIdB - alvIdA
      })
      
      // Auto-select first option and show warning if none (no watchers, contained here)
      if (this.isMappingImport && retArr.length > 0) {
        const selected = this.$store.getters.getAzPersonsDetailsImportSelectedMapping
        const found = retArr.find(o => o.value === selected)
        if ((selected === null || selected === undefined || !found) && retArr[0].disabled === false) {
          this.$store.commit('setAzPersonsDetailsImportSelectedMapping', retArr[0].value)
        }
      }
      if (this.isMappingImport && retArr.length === 0 && this.$store.getters.getIsLoading === false) {
        const warn = this.$t('lang_GENERIC_MESSAGE_WARNING_NO_MAPPINGS_AVAILABLE_FOR_DOMAIN')
        this.$store.commit('setImportDialogText', `<span class=\"error--text\">${warn}</span>`)
      }
      
      return retArr
		},
  },
  methods: {
    getNameTooltip(item) {
      let tooltip = item.name
      if (item.ipi) tooltip = tooltip + " [IPI: " + item.ipi + "]"
      return tooltip
    },

    showImageUploadDialog(item){
      this.$store.commit('setImageUploaderContext',this.context)
      if(item.picture !== null){
          this.$store.commit('setImageUploaderImageExists',true)
      }
      item.otherIds = null
      this.$store.commit('set' + this.context + 'Details', item)
      this.$store.commit("setShowImageUploadDialog",true)
    },
    getMappings() {
      this.$store.commit('setSelectedMappingsDomainsFilter', 'az_persons')
      this.$store.dispatch('fetchMappingsByDomain')
    },
  },
  watch: {
  },
  created() {
    this.getMappings()
    this.$store.commit('setSelectedAzPersonsVisibilityFilter', ['visible', 'hidden'])
  }
}
</script>
